import InfoContainer from '../InfoContainer';

import Skeleton from './Skeleton';

export default function PublicationPetSkeleton() {
  return (
    <InfoContainer>
      {/* Верхняя часть: дата публикации и просмотры */}
      <div className="mb-4 inline-flex w-full items-center justify-between text-sm md:text-base">
        <Skeleton className="h-4 w-40 rounded" />
        <Skeleton className="h-4 w-20 rounded" />
      </div>

      {/* Порода */}
      <Skeleton className="mb-2 h-8 w-48 rounded" />

      {/* Цена */}
      <Skeleton className="mb-2 h-10 w-56 rounded" />

      {/* Пол */}
      <Skeleton className="mb-2 h-6 w-32 rounded" />

      {/* Возраст */}
      <Skeleton className="mb-2 h-6 w-32 rounded" />

      {/* Цвет */}
      <Skeleton className="mb-2 h-6 w-32 rounded" />

      {/* Кличка */}
      <Skeleton className="mb-2 h-6 w-32 rounded" />

      {/* Исправить объявление (скелетон для ссылки) */}
      <Skeleton className="mt-4 h-6 w-40 rounded" />
    </InfoContainer>
  );
}
